<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>政策解读</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>政策解读</a></li>
                    <li><router-link to="/layout/policy-interpretation" class="active">政策解读</router-link></li>
                    <!-- <li><router-link to="">知识分享</router-link></li> -->
                </ul>
                <div class="page-content">
                    <h3>政策解读</h3>
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        :show-header="false">
                        <el-table-column
                            label="内容"
                            min-width="820">
                            <template slot-scope="scope">
                                <p class="policy" @click="goDetail(scope.row)">
                                    <span class="dot"></span>
                                    <span class="ellipsis_one rowContent">{{ scope.row.Title }}</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="日期"
                            width="120">
                            <template slot-scope="scope">
                               <span>{{ scope.row.UpdateTime }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :currentPage="currentPage"
                        :pageSize="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getZhengceList
} from '@services/indexService.js';
export default {
    name:"",
    data() {
        return {
            tableData:[],
            total: 0,
            currentPage: 1,
            pageSize: 10,
        }
    },
    created() {
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.getZhengceList();
    },
    methods: {
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/policy-detail',
                query: {
                    id: data.Id,
                    page: this.currentPage
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getZhengceList();
        },
        getZhengceList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
            };
            getZhengceList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = res.Data;
                    this.total = res.Count;
                } else {
                    this.$message.error("政策解读请求失败");
                }
            })

        }
    }
}
</script>

<style scoped>
.policy{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor:pointer;
}
.policy span {
    flex-shrink: 0;
    flex-grow: 0;
}
.rowContent {
    width: 810px;
}
.policy:hover {
    color: #116EBA;
}
.policy:hover .dot {
    background: #116EBA;
}
</style>